<template>
  <div style="padding-top: 150px">
    <!-- 导航 -->

    <mynav></mynav>
    <div class="banner">
      <div class="am-g">
        <div>
          <img
            src="../../assets/i/banner/job1.jpg"
            alt=""
            class="am-img-responsive banner-news"
          />
        </div>
      </div>
    </div>

    <div class="jobpost-box">
      <div class="jobpost-main">
        <div id="about1" class="jobpost-target"></div>
        <h1>招聘岗位</h1>
        <hr style="height: 1px; border: none; border-top: 1px solid black" />
        <div class="am-container jobpost-art">
          <div class="job-art-box">
            <h2>{{dataList.title}}</h2>
            <p>{{ dataList.position }}</p>
            <p>职位描述:</p>
            <p v-html="dataList.job"></p>
            <p>任职要求:</p>
            <p v-html="dataList.ask"></p>
          </div>
          <div class="jobpost-button">
            <!--调用公司邮箱-->
            <a
              href="mailto:weiwei.hu@pujinhj.com"
              title="weiwei.hu@pujinhj.com"
              class="am-btn am-btn-secondary am-round"
            >
              立即申请
            </a>
            <div
              @click="$router.push('/recruit')"
              class="am-btn am-btn-default am-round"
              style="margin: 0 30px"
            >
              返回列表
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="clear: both"></div>
    <div style="padding-top: 40px">
      <myfooter></myfooter>
    </div>
  </div>
</template>
<script>
import "../../assets/css/amazeui.min.css";
import mynav from "../../components/nav.vue";
import myfooter from "../../components/footer.vue";
export default {
  data() {
    return {
      id: "",
      dataList: "",
      lab: "",
    };
  },
  components: {
    mynav,
    myfooter,
  },
  watch: {
    $route() {
      this.myload();
    },
  },
  created() {
    this.myload();
  },
  mounted() {},
  methods: {
    myload() {
      this.id = this.$route.params.id;
      this.lab = this.$route.query.lab || "ALL";
      this.$axios
        .get(`/front/getFrontRecordInfo?recId=${this.id}&lab=${this.lab}`)
        .then((res) => {
          this.dataList = res.data;
        });
    },
  },
};
</script>
<style scoped lang="less">
.jobpost-box {
  max-width: 1200px;
  margin: 0 auto;
  clear: both;
}
.jobpost-main {
  width: 90%;
  float: right;
  margin: 50px auto;
  background: white;
}
.jobpost-art {
  margin: 30px auto;
}
.news-ul {
  float: left;
  list-style: none;
  z-index: 9999;
}
.news-li {
  margin: 35px 0;
  padding-left: 20px;
  background: url("../../assets/i/backline.png") 0 no-repeat;
}
.news-li > a {
  color: #7a7a7a;
}
.li-img {
  margin: 25px 0 25px 10px;
  padding-left: 13px;
  background: url("../../assets/i/timeframe.png") 0 no-repeat;
}
.li-img > a {
  color: #fff;
}
.jobpost-target {
  position: relative;
  top: -100px;
}
.jobpost-line {
  height: 200px;
  width: 2px;
  background: skyblue;
  position: relative;
  top: 200px;
  left: 5px;
  z-index: -1;
}
.jobpost-button {
  text-align: center;
  margin: 0 20px;
}
.btn-hide {
  text-align: center;
  margin-top: 20px;
}
.job-art-box {
  word-wrap: break-word;
  word-break: normal;
}
</style>